var map = {
	"./back-icon.svg": 4681,
	"./bell.svg": 9178,
	"./biggan-chinta.svg": 8291,
	"./bondhushava.svg": 3006,
	"./bookmark-outline.svg": 8411,
	"./close-white.svg": 6641,
	"./close.svg": 9525,
	"./comments-outline.svg": 3045,
	"./default-author-image.svg": 9191,
	"./default-card-image.svg": 1763,
	"./envelope.svg": 8163,
	"./fb-blue.svg": 6158,
	"./fb-whitebg.svg": 238,
	"./fb.svg": 3836,
	"./fullscreen-exit.svg": 5291,
	"./fullscreen.svg": 5204,
	"./gallery-scope.svg": 2384,
	"./gallery-whitebg.svg": 9895,
	"./google-icon.svg": 557,
	"./kishoralo-white.svg": 147,
	"./kishoralo.svg": 2992,
	"./launcher.svg": 5151,
	"./media-placeholder.svg": 6034,
	"./messenger.svg": 255,
	"./nagorik.svg": 4918,
	"./next-story.svg": 7641,
	"./palo-bangla.svg": 9249,
	"./palo-english.svg": 1993,
	"./prothomalo-trust.svg": 3462,
	"./protichinta-logo.svg": 5221,
	"./search.svg": 6759,
	"./sun.svg": 4060,
	"./twitter-whitebg.svg": 8762,
	"./video-whitebg.svg": 4427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1006;